import React from 'react';
import styled from "styled-components";

const Wrapper = styled.div`
    display: inline-block;
    width: ${props => props.widthWrapper || '100%'};
    margin-top: 30px;

    ${props => props.theme.mediaQueries.medium}{
        max-width: ${props => props.maxWidthWrapperMediaQueriesMedium || '250px'};
    };

    ${props => props.theme.mediaQueries.large}{
        max-width: ${props => props.maxWidthMediaQueriesLarge};
    };
`;

const Icon = styled.svg`
    width: ${props => props.widthIcon || '36px'};
    height: ${props => props.heightIcon || '36px'};
    display: inline-block;
    background-image: url(${props => props.backgroundImg});
    background-repeat: no-repeat;
    
    ${props => props.theme.mediaQueries.medium}{
        margin-top: ${props => props.marginTopIconMediaQueriesMedium | '50px'};
    };
`;

const Header = styled.p`
    font-size: ${props => props.fontSizeHeader || '1.66rem'};
    line-height: ${props => props.lineHeightHeader || '24px'};
    margin-top:  ${props => props.marginTopHeader || '16px'};

    ${props => props.theme.mediaQueries.medium}{
        font-size: ${props => props.fontSizeHeaderMediaQueriesMedium || '0.9rem'};
        margin-top: ${props => props.marginTopHeaderMediaQueriesMedium}
    };
`

const P = styled.p`
    line-height: 20px;
    font-size: ${props => props.fontSizeP || '1.16rem'};
    margin-top: ${props => props.marginTopP || '4px'};

    ${props => props.theme.mediaQueries.medium}{
        font-size: ${props => props.fontSizePMediaQueriesMedium || '0.7rem'};
        margin-top: ${props => props.marginTopPMediaQueriesMedium}
        //max-width: 250px;
    };
`      

const IconTextTopDown = ({ 
    backgroundImg,
    headerText,
    paragraphText,
    ...props
}) => {
    return (
        <Wrapper {...props}>
            <Icon
                {...props}
                backgroundImg={backgroundImg}
            />
            {headerText && <Header {...props}>{headerText}</Header>}
            {paragraphText && <P {...props}>{paragraphText}</P>}
        </Wrapper>
    )
}

export default IconTextTopDown;